import { Component, Renderer, ElementRef, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { OnInit, Input, Output, EventEmitter } from '@angular/core';

// import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { JhiEventManager } from 'ng-jhipster';

import { LoginService } from 'src/app/core/login/login.service';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { Principal } from 'src/app/core/auth/principal.service';
import { HistoryService } from './history.service';

@Component({
  selector: 'jhi-history',
  templateUrl: './history.component.html',

})
export class JhiHistoryComponent implements OnChanges, OnInit {

  @Output() readToggleEvent = new EventEmitter<boolean>();
  // @Input() historyList = [];
  @Input() title: string;
  @Input() htype: string;
  @Input() type: string;
  @Input() id: number;

  // page: number = 0;
  // currentPage: number = 0;
  nextPage: boolean = false;
  historyList = [];

  totalItems: any;
  queryCount: any;
  itemsPerPage: any = 5;
  page: any = 1;
  predicate: any;
  previousPage: any;
  reverse: any;

  // @Input() historyList = [];
  @Input() readToggleBoolean = true;
  isClosingTab: boolean = false;
  constructor(
    public principal: Principal,
    private historyService: HistoryService, // public activeModal: NgbActiveModal,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // throw new Error("Method not implemented.");
  }
  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);
    // console.log(this.title);
    // console.log(this.type);
    // console.log(this.id);

    // this.page = 0;
    // this.currentPage = 0;
    // this.nextPage = false;

    if (this.readToggleBoolean) {
      this.page = 1;
      this.previousPage = 0;
      this.historyList = [];
      if (this.id != null && this.id != undefined) {
        this.getHistoryByType();
      }
    }
  }

  getHistoryByType() {
    let for_data = {
      auditLogType: this.type,
      auditLogId: this.id,
      pageNo: this.page - 1,
      size: this.itemsPerPage
    }

    this.historyService.getAuditLogByTypeForDataManagement(for_data).subscribe(response => {
      console.log(response);
      this.nextPage = response.body.nextPage;
      this.totalItems = response.body.totalRecords;
      this.queryCount = this.totalItems;
      this.historyList = response.body.auditLogDTOList;
      this.principal.isHistoryFuturePopupShown = true;
      this.principal.showContent=true;
      this.ref.detectChanges();
      // if (response.isSuccess) {
      //   console.log(response.payLoad);
      //   if (response.payLoad.auditLogDTOList != null) {
      //     this.nextPage = response.payLoad.nextPage;
      //     this.historyList = response.payLoad.auditLogDTOList;
      //   }
      // } else {
      //   this.nextPage = false;
      //   this.historyList = [];
      // }
    });
  }

  historyToggle() {
    // this.isClosingTab = true;
    this.readToggleBoolean = false;
    this.principal.isHistoryFuturePopupShown=false
    this.readToggleEvent.emit(false);
  }

  // setPage(currentPage) {
  //   if (currentPage != null) {
  //     console.log(currentPage);
  //     this.currentPage = currentPage;
  //     this.getHistoryByType();
  //   }
  // }

  loadPage(page) {
    if (page !== this.previousPage) {
      this.previousPage = page;
    }
    this.getHistoryByType();
  }
}
